const HEX_COLOR = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

const toHexByte = (channel: number): string =>
  Math.min(255, Math.max(0, Math.round(channel))).toString(16).padStart(2, "0");

/**
 * Darkens a `#rgb` / `#rrggbb` colour by multiplying each RGB channel by
 * `factor` (0.8 = 20% darker), returning lowercase `#rrggbb`.
 *
 * Returns `null` for anything that is not a 3- or 6-digit hex colour (named
 * colours, `rgb()`, 8-digit alpha hex, a missing `#`), so callers can fall
 * back to a default instead of painting a guessed value. Used to derive the
 * launcher's hover (`-strong`) shades from the Hub launcher colours (LAS-4753).
 */
export const darkenHex = (hex: string, factor = 0.8): string | null => {
  const match = HEX_COLOR.exec(hex);
  if (!match) return null;
  const digits = match[1].length === 3
    ? match[1].split("").map((d) => d + d).join("")
    : match[1];
  const channels = [0, 2, 4].map((i) => parseInt(digits.slice(i, i + 2), 16) * factor);
  return `#${channels.map(toHexByte).join("")}`;
};
